import React, {Component} from 'react';

import Button from '../../components/Button';
import SocialSeen from './SocialSeen';
import SocialActivities from './SocialActivities';
import SocialFollowings from './SocialFollowings';
import SocialFollowers from './SocialFollowers';
import SocialMessages from '../../components/Social/SocialMessages';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';

class SocialTabsManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
    }
  }

  componentDidMount() {
    window.SpatialNavigation.set({
      tabIndexIgnoreList: 'input, select, textarea, button, iframe',
    });

    window.SpatialNavigation.makeFocusable();
    const tab = document.querySelector('.tab-1');
    tab.classList.add('social-active');

    const panel = document.querySelector('.tabs-panel > .panel-1');
    panel.classList.add('panel-show');

    this.setState({ active: 1 });
  }

  showTab(idx) {
    const panels = document.querySelector('.tabs-panel');
    const divElements = panels.getElementsByTagName('div');

    for (var i = divElements.length - 1; i >= 0; i--) {
      divElements[i].classList.remove('panel-show');
    }

    const panel = document.querySelector(`.tabs-panel > .panel-${idx}`);
    panel.classList.add('panel-show');
  }

  changeTab(idx) {
    const currentItem = document.querySelector(`.tab-${this.state.active}`);
    currentItem.classList.remove('social-active');

    const tab = `.tab-${idx}`;
    const x = document.querySelector(tab);
    if (x) {
      x.classList.add('social-active');
      this.showTab(idx);
      this.setState({ active: idx })
    }
    if (typeof this.props.setMetricsEvent === 'function') {
      this.sendMetric(idx);
    }

  }

  sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor' });
  }

  sendMetric(idx) {
    if (typeof this.props.setMetricsEvent === 'function') {
      let label;
      switch (idx) {
        case 1:
          label = 'actividad reciente';
          break;
        case 2:
          label = 'siguiendo';
          break;
        case 3:
          label = 'seguidores';
          break;
        case 4:
          label = 'mensajes';
          break;
      }
      this.props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'perfil',
        eventAction: 'click',
        eventLabel: label,
      });
      this.props.setMetricsEvent({ type: 'executor' });
      this.sendDimension();
    }
  }

  render() {
    const tab = 24;
    const tabButtonStyle = {
      padding: 10,
      borderRadius: 30,
    };

    return (<div className="tab-frame invisible-scrollbar">

      <div className="Tabs">
        <ul>
          <li className="tab-1" style={{ width: tab + 3 + '%' }}>
            <Button
              style={tabButtonStyle}
              onClick={this.changeTab.bind(this, 1)}
              text={this.props.translations.get('social_recent_activity', 'ACTIVIDADES RECIENTES').toUpperCase()}
            />
          </li>
          <li className="tab-2" style={{ width: tab + '%' }}
          >
            <Button
              style={tabButtonStyle}
              onClick={this.changeTab.bind(this, 2)}
              text={this.props.translations.get('social_following', 'SIGUIENDO').toUpperCase()}
            />
          </li>
          <li className="tab-3" style={{ width: tab + '%' }}
          >
            <Button
              style={tabButtonStyle}
              onClick={this.changeTab.bind(this, 3)}
              text={this.props.translations.get('social_followers', 'SEGUIDORES').toUpperCase()}
            />
          </li>
          {this.props.isCurrentUser && <li className="tab-4" style={{ width: tab + '%' }}
          >
            <Button
              style={tabButtonStyle}
              onClick={this.changeTab.bind(this, 4)}
              text={this.props.translations.get('social_messages', 'MENSAJES').toUpperCase()}
            />
          </li>}
        </ul>

        <div className="tabs-panel">
          <div className="panel-1">
            <SocialSeen
              gamificationId={this.props.gamificationId}
              translations={this.props.translations}
              setMetricsEvent={this.props.setMetricsEvent}
              getLinks={this.props.getLinks}
            />
            <SocialActivities
              gamificationId={this.props.gamificationId}
              translations={this.props.translations}
              gameId={this.props.gameId}
              userSocial={this.props.userSocial}
              isCurrentUser={this.props.isCurrentUser}
            />
          </div>
          <div className="panel-2">
            <SocialFollowings
              gamificationId={this.props.gamificationId}
              userSocial={this.props.userSocial}
              gameId={this.props.gameId}
              translations={this.props.translations}
              isCurrentUser={this.props.isCurrentUser}
              gamificationIdUserlogged={this.props.gamificationIdUserlogged}
              ownFollowings={this.props.ownFollowings}
              incOwnFollowings={this.props.incOwnFollowings}
              decOwnFollowings={this.props.decOwnFollowings}
              showModal={this.props.showModal}
              user={this.props.user}
            />
          </div>
          <div className="panel-3">
            <SocialFollowers
              gamificationId={this.props.gamificationId}
              userSocial={this.props.userSocial}
              gameId={this.props.gameId}
              translations={this.props.translations}
              isCurrentUser={this.props.isCurrentUser}
              gamificationIdUserlogged={this.props.gamificationIdUserlogged}
              ownFollowings={this.props.ownFollowings}
              incOwnFollowings={this.props.incOwnFollowings}
              decOwnFollowings={this.props.decOwnFollowings}
              showModal={this.props.showModal}
              user={this.props.user}
            />
          </div>
          <div className="panel-4">
            <SocialMessages messages={this.props.messages} />
          </div>

        </div>
      </div>
    </div>);
  }

}

export default SocialTabsManager;



// WEBPACK FOOTER //
// ./src/containers/Social/SocialTabsManager.jsx